/*
 * Public API Surface of @mmscan/angular-ui/app-shell
 */

export * from './app-shell';
export * from './logo';
